import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { environment } from '../../../environments/environment';

export const navigateTo = (url: string): void => {
    window.location.href = url;
};

export const externalRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const key = route.data['externalRedirect'] as keyof typeof environment.externalRedirects;
    const externalUrl = environment.externalRedirects?.[key];

    if (!externalUrl) {
        return true;
    }

    const usedParams = new Set<string>();
    const interpolated = externalUrl.replace(/\{(\w+)\}/g, (_, param) => {
        usedParams.add(param);
        return route.queryParams[param] ?? '';
    });

    const remaining = Object.entries(route.queryParams as Record<string, string>).filter(([k]) => !usedParams.has(k));
    const queryString = new URLSearchParams(remaining).toString();

    navigateTo(queryString ? `${interpolated}?${queryString}` : interpolated);
    return false;
};
